import { orderService } from "@/api/orderService"
import { useMutation, useQueryClient } from "@tanstack/react-query"
import { toast } from "sonner"

export const useCreateOrder = () => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: ({
      orderData,
      orderId,
    }: {
      orderData: any
      orderId?: number
    }) => {
      if (orderId) {
        return orderService.updateOrder(orderId, orderData)
      }
      return orderService.createOrder(orderData)
    },
    onSuccess: (_, variables) => {
      toast.success(
        variables.orderId
          ? "Order updated successfully"
          : "Order created successfully"
      )
      queryClient.invalidateQueries({ queryKey: ["order"] })
    },
    onError: (error: any) => {
      // 1. Log the full error for debugging
      console.log("Full error object:", error)

      // 2. Extract validation errors if they exist
      // Note: Depending on your axios/fetch setup, you might need error.response?.data
      const errorData = error?.response?.data || error
      const validationErrors = errorData?.error

      if (validationErrors && typeof validationErrors === "object") {
        // Get the first key (e.g., "cash_received")
        const firstKey = Object.keys(validationErrors)[0]
        // Get the first message for that key
        const firstMessage = validationErrors[firstKey][0]

        toast.error(firstMessage)
      } else {
        // 3. Fallback to the general message or a default string
        toast.error(errorData?.message || "Failed to process order")
      }
    },
  })
}
